import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M74.82 114.8c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M101.5 31.97a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path fill="#D8FFFF" d="M8.57 69.28a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      d="m12.19 91.5 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM113.64 49.07h-5.57V43.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H99.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5"
    />
    <path
      fill="#0597A3"
      d="M93 29.703c0-3.7-3.007-6.703-6.714-6.703H28.724C25.017 23 22 26.003 22 29.703V47h71z"
    />
    <path
      fill="#00D8D8"
      d="M22 47v40.279A6.72 6.72 0 0 0 28.724 94h57.562A6.72 6.72 0 0 0 93 87.279V47z"
    />
    <path
      fill="#001A43"
      d="M81.898 54h-4.796c-1.16 0-2.102.941-2.102 2.102v4.796c0 1.16.941 2.102 2.102 2.102h4.796c1.16 0 2.102-.941 2.102-2.102v-4.796c0-1.16-.941-2.102-2.102-2.102"
    />
    <path
      fill="#00D8D8"
      d="M40.25 30.78c-1.24 0-2.25-1.01-2.25-2.25V17.55c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v10.98c0 1.24-1.01 2.25-2.25 2.25M75.42 30.78c-1.24 0-2.25-1.01-2.25-2.25V17.55c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v10.98c0 1.24-1.01 2.25-2.25 2.25"
    />
    <path
      fill="#001A43"
      d="M39.898 54h-4.796c-1.16 0-2.102.941-2.102 2.102v4.796c0 1.16.941 2.102 2.102 2.102h4.796c1.16 0 2.102-.941 2.102-2.102v-4.796c0-1.16-.941-2.102-2.102-2.102M60.898 54h-4.796c-1.16 0-2.102.941-2.102 2.102v4.796c0 1.16.941 2.102 2.102 2.102h4.796c1.16 0 2.102-.941 2.102-2.102v-4.796c0-1.16-.941-2.102-2.102-2.102M39.898 73h-4.796c-1.16 0-2.102.941-2.102 2.102v4.796c0 1.16.941 2.102 2.102 2.102h4.796c1.16 0 2.102-.941 2.102-2.102v-4.796c0-1.16-.941-2.102-2.102-2.102M60.898 73h-4.796c-1.16 0-2.102.941-2.102 2.102v4.796c0 1.16.941 2.102 2.102 2.102h4.796c1.16 0 2.102-.941 2.102-2.102v-4.796c0-1.16-.941-2.102-2.102-2.102"
    />
  </svg>
);
const SvgEnrichedIconScheduleBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconScheduleBrand);
export default Memo;
